// Lukos Blog Page - Main Entry
import React, { useState, useEffect, useRef, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { faqItems, blogPostsData as blogPosts } from '../../constants/homeData';
import {
  Calendar, Clock, User, ArrowRight, ArrowDown, BookOpen, Tag, FileText, Cloud,
  CreditCard, Gift, Smartphone, Wallet, Receipt, ShoppingCart, BarChart3, Database,
  Package, DollarSign, TrendingUp, ChevronLeft, ChevronRight, HelpCircle, ChevronDown,
  ChevronUp, CheckCircle, ArrowUp, Percent, MessageCircle, Play, X, Rocket, Users,
  Edit, Zap, Brain, Cpu, Eye, ShieldCheck, Users2, CheckCircle2, LineChart, Target,
  Sparkles, PieChart, Lock, Activity, Instagram, Facebook, Youtube, Mail, Phone,
  MapPin, MessageSquare, LayoutDashboard, ArrowLeftRight
} from 'lucide-react';
import { motion, AnimatePresence, useMotionValue, useTransform, useSpring, animate, useInView } from 'framer-motion';
import BentoGrid from '../../components/custom/BentoGrid/BentoGrid';
import ProcessSection from '../../components/custom/ProcessSection/ProcessSection';
import CtaDivider from '../../components/custom/CtaDivider/CtaDivider';
import HistorySection from '../../components/custom/HistorySection/HistorySection';
import LandingHero from '../../components/custom/LandingHero/LandingHero';
import ServicePresentation from '../../components/custom/ServicePresentation/ServicePresentation';
import ServiceDiferencial from '../../components/custom/ServiceDiferencial';
import TrustSection from '../../components/custom/TrustSection/TrustSection';
import BlogHeroSection from '../../components/custom/BlogHeroSection/BlogHeroSection';
import PartnersSection from '../../components/custom/PartnersSection/PartnersSection';
import SeenProductFeature from '../../components/custom/SeenProductFeature/SeenProductFeature';
import SmartPOSFeatureSection from '../../components/custom/SmartPOSFeatureSection/SmartPOSFeatureSection';
import LukIA from '../../components/custom/LukIA/LukIA';
import LukosSolutionsShowcase from '../../components/custom/LukosSolutionsShowcase/LukosSolutionsShowcase';
import LukIAFeature from '../../components/custom/LukIAFeature/LukIAFeature';
import AgentsIASection from '../../components/custom/AgentsIASection/AgentsIASection';
import FunctionalitiesDeepDive from '../../components/custom/FunctionalitiesDeepDive/FunctionalitiesDeepDive';
import ConciliacaoFeaturesSection from '../../components/custom/ConciliacaoFeaturesSection/ConciliacaoFeaturesSection';
import LukosEcosystemDiagram from '../../components/custom/LukosEcosystemDiagram/LukosEcosystemDiagram';
import EvolutionSection from '../../components/custom/EvolutionSection/EvolutionSection';
import SolutionsSection from '../../components/custom/SolutionsSection/SolutionsSection';
import FeaturesShowcase from '../../components/custom/FeaturesShowcase/FeaturesShowcase';
import EventsSection from '../../components/custom/EventsSection/EventsSection';
import BackOfficeSection from '../../components/custom/BackOfficeSection/BackOfficeSection';
import ConciliationSection from '../../components/custom/ConciliationSection/ConciliationSection';
import ERPProcessSection from '../../components/custom/ERPProcessSection/ERPProcessSection';
import SystemRibbonSection from '../../components/custom/SystemRibbonSection/SystemRibbonSection';
import AdvantagesSection from '../../components/custom/AdvantagesSection/AdvantagesSection';
import CinematicSlider from '../../components/custom/CinematicSlider/CinematicSlider';
import ServiceCardGrid from '../../components/custom/ServiceCardGrid/ServiceCardGrid';
import SystemShowcaseTabs from '../../components/custom/SystemShowcaseTabs';
import CommunitySection from '../../components/custom/CommunitySection';
import LukosStatsRibbon from '../../components/custom/LukosStatsRibbon/LukosStatsRibbon';
import HeroBannerSlider from '../../components/custom/HeroBannerSlider/HeroBannerSlider';
import LukosPayDiscoverMore from '../../components/custom/LukosPayDiscoverMore/LukosPayDiscoverMore';

import LukosVideoShowcase from '../../components/custom/LukosVideoShowcase/LukosVideoShowcase';
import HeroVideoSmart from '../../components/custom/HeroVideoSmart/HeroVideoSmart';
import LukosEcommerceShowcase from '../../components/custom/LukosEcommerceShowcase/LukosEcommerceShowcase';







import LukosConnectivityMap from '../../components/custom/LukosConnectivityMap/LukosConnectivityMap';


import LukosInnovationHub from '../../components/custom/LukosInnovationHub/LukosInnovationHub';
import Herosectionhome from '@/components/custom/HeroSectionHome/Herosectionhome';
import Support24hSection from '../../components/custom/Support24hSection/Support24hSection';
import ScheduleTrainingSection from '../../components/custom/ScheduleTrainingSection/ScheduleTrainingSection';
import LukosAppStoreSection from '../../components/custom/LukosAppStoreSection/LukosAppStoreSection';
import LukosSolutionsRedirect from '../../components/custom/LukosSolutionsRedirect/LukosSolutionsRedirect';
import LukosMarketplaceSection from '../../components/custom/LukosMarketplaceSection/LukosMarketplaceSection';
import LukosUnifiedBanner from '../../components/custom/LukosUnifiedBanner/LukosUnifiedBanner';
import LukosSolutionsSplit from '../../components/custom/LukosSolutionsSplit/LukosSolutionsSplit';
import Integracoes from '../../components/custom/Integracoes/Integracoes';
import GlobalPageBackground from '../../components/custom/GlobalPageBackground/GlobalPageBackground';
import LukosInteractiveSolutions from '../../components/custom/LukosInteractiveSolutions/LukosInteractiveSolutions';




function BlogPage() {
  // Estado para FAQ
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);


  // Ref para o container de scroll
  const containerRef = useRef<HTMLDivElement>(null);

  // Estado para controlar modal de vídeo
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  // Estado da aba ativa nas Soluções interativas (espelha /solucoes)
  const [activeSolutionTab, setActiveSolutionTab] = useState('LUK');

  // Estado para botão Scroll to Top
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      if (container.scrollTop > 500) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  // Dados foram migrados para constants/homeData.ts

  return (
    <div className="relative min-h-screen bg-white overflow-x-clip">
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>

      {/* ─── Global Background Decorative System ──────────────────────
          Blobs radiais + fios diagonais, repetidos a cada ~1400px de rolagem,
          para dar a sensação de um único fundo contínuo por trás de toda a
          página — não só atrás de uma seção específica. Fica visível nas
          bordas/gaps entre seções com fundo próprio, e por completo nas
          seções que não pintam um fundo opaco sobre ele. */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden z-0" aria-hidden>
        <GlobalPageBackground top={0} />
        <GlobalPageBackground top={1400} />
        <GlobalPageBackground top={2800} />
        <GlobalPageBackground top={4200} />
        <GlobalPageBackground top={5600} />
        <GlobalPageBackground top={7000} />
        <GlobalPageBackground top={8400} />
      </div>

      <div className="relative z-10">
        <LandingHero />
        <TrustSection />
      <LukosSolutionsSplit />
      <Integracoes />
      <LukosInteractiveSolutions
        activeTab={activeSolutionTab}
        onTabChange={setActiveSolutionTab}
      />
      <LukosVideoShowcase />
      <Support24hSection />
      <ScheduleTrainingSection />
      <LukosAppStoreSection />

      <LukosUnifiedBanner />

      {/* FAQ Section */}
      <section className="py-24 bg-slate-50 relative z-10">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-16 w-full lg:w-[80%] mx-auto">
            <span className="text-purple-600 font-bold tracking-wider uppercase text-sm mb-4 block">Tire Suas Dúvidas</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight">Perguntas Frequentes</h2>
            <p className="text-slate-500 text-lg max-w-2xl mx-auto">Tudo o que você precisa saber sobre o sistema LUKOS para decolar o seu posto de combustível.</p>
          </div>
          <div className="space-y-4 w-full lg:w-[80%] mx-auto">
            {faqItems.map((item, index) => {
              const isOpen = openFaqIndex === index;
              return (
                <motion.div 
                  key={index} 
                  initial={false}
                  animate={{ backgroundColor: isOpen ? '#ffffff' : '#ffffff' }}
                  className={`border border-slate-200/60 rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'shadow-xl shadow-purple-900/5 ring-1 ring-purple-500/20' : 'shadow-sm hover:shadow-md hover:border-purple-200'}`}
                >
                  <button
                    onClick={() => setOpenFaqIndex(isOpen ? null : index)}
                    className="w-full p-6 text-left flex justify-between items-center group focus:outline-none"
                  >
                    <span className={`font-bold text-lg transition-colors duration-200 pr-8 ${isOpen ? 'text-purple-700' : 'text-slate-800 group-hover:text-purple-600'}`}>
                      {item.question}
                    </span>
                    <div className={`flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full transition-colors duration-300 ${isOpen ? 'bg-purple-100 text-purple-600' : 'bg-slate-100 text-slate-500 group-hover:bg-purple-50 group-hover:text-purple-500'}`}>
                      <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
                    </div>
                  </button>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        className="overflow-hidden"
                      >
                        <div className="p-6 pt-0 pb-8 text-slate-600 leading-relaxed text-[15px] sm:text-base border-t border-slate-100/50 mt-2">
                          {item.answer}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section> 

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-8 right-8 w-14 h-14 bg-purple-600 text-white rounded-full shadow-2xl flex items-center justify-center z-100 hover:bg-purple-700 transition-colors"
        >
          <ArrowUp size={24} />
        </motion.button>
      )}
      </div>
    </div>
  );
}

export default BlogPage;
